import { gql, useMutation } from 'urql';
import * as amplitude from '@amplitude/analytics-browser';
import { toast } from 'sonner';

import { useUser } from '@/components/auth-provider';
import LoginForm from '@/ui/login/LoginForm';

const loginQuery = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      code
      user {
        id
        name
      }
      success
      exp
    }
  }
`;

export default function LoginScreen() {
  const [, login] = useMutation(loginQuery);
  const { setUser } = useUser();

  async function submitLogin(email: string, password: string) {
    try {
      const result = await login(
        { email, password },
        {
          fetchOptions: {
            credentials: 'include',
            mode: 'cors',
          },
        },
      );

      if (result.data?.login.code !== 'LOGIN_SUCCESS') {
        throw new Error();
      }

      const { id, name } = result.data.login.user;

      setUser();

      // Amplitude user IDs must be at least 5 characters
      const amplitudeId = id.toString().padStart(5, '0');

      amplitude.track('login', {
        amplitudeId,
        userName: name,
        userEmail: email,
      });
      location.reload();
    } catch (error) {
      toast.error(
        'Login failed. Please check your email and password and try again.',
      );
    }
  }

  return (
    <LoginForm
      onSubmit={(data) => {
        submitLogin(data.email, data.password);
      }}
    />
  );
}
